import { instance } from "config/axiosInstance";

/**
 * Get revenue recognition schedule
 * @param {string} pathname - e.g. `/revenue` atau `/revenue/:id`
 * @param {object} queryParams - query string params
 * @param {object} headers - custom headers
 */
export const getRevenue = (pathname, queryParams, headers) => {
  return instance.get(pathname, {
    params: queryParams,
    headers,
  });
};

/**
 * Generate revenue recognition & cash flow schedule dari service data
 * @param {string} pathname - e.g. `/revenue/generate`
 * @param {object} body - payload service data
 * @param {object} queryParams
 */
export const generateRevenue = (pathname, body, queryParams) => {
  return instance.post(pathname, body, {
    params: queryParams,
  });
};

/**
 * Update revenue schedule (misal revisi harga / tanggal)
 * @param {string} pathname - e.g. `/revenue/:id`
 * @param {object} body
 */
export const updateRevenue = (pathname, body) => {
  return instance.put(pathname, body);
};

/**
 * Delete revenue schedule
 * @param {string} pathname - e.g. `/revenue/:id`
 */
export const deleteRevenue = (pathname) => {
  return instance.delete(pathname);
};

/**
 * Export revenue schedule ke PDF / Excel
 * @param {string} pathname - e.g. `/revenue/:id/export`
 * @param {object} queryParams - { format: 'pdf' | 'xlsx' }
 */
export const exportRevenue = (pathname, queryParams) => {
  return instance.get(pathname, {
    params: queryParams,
    responseType: "blob",
  });
};
